module.exports = __webpack_public_path__ + "static/media/sidebar-8.9f314094.png";